import React, { useRef, useEffect } from 'react';

const VideoPlayer = ({ video, onClose }) => {
  const videoRef = useRef(null);

  useEffect(() => {
    const videoElement = videoRef.current;
    if (!videoElement) return;

    // Properly encode the URL to handle spaces and special characters
    const encodedUrl = video.videoUrl.replace(/\s+/g, '%20');

    // Set the video source
    videoElement.src = encodedUrl;
    
    // Add event listeners for better user experience
    videoElement.addEventListener('loadedmetadata', () => {
      console.log('Video metadata loaded');
    });

    videoElement.addEventListener('error', (e) => {
      console.error('Video error:', e);
    });

    videoElement.addEventListener('canplay', () => {
      console.log('Video can start playing');
    });

    return () => {
      if (videoElement) {
        videoElement.src = '';
        videoElement.load();
      }
    };
  }, [video.videoUrl]);

  return (
    <div className="bg-white bg-opacity-25 p-2 rounded-lg overflow-hidden shadow-lg">
      <div className="relative">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 z-10 bg-black bg-opacity-50 rounded-full p-2 hover:bg-opacity-70 transition-all"
        >
          <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
        
        <div className="flex flex-col">
          <div className="relative w-full aspect-video">
            <video
              ref={videoRef}
              className="absolute inset-0 w-full h-full object-contain bg-black"
              controls
              controlsList="nodownload"
              onContextMenu={(e) => e.preventDefault()}
              playsInline
              preload="metadata"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default VideoPlayer; 